import {useEffect, useState} from 'react';
import {Spinner} from 'src/components/layout/loader/Spinner';
import {toDropinArrivalPerson, useArrivalContext} from 'src/context/ArrivalContext';
import {useSessionContext} from 'src/context/SessionContext';
import {performDropinArrival} from 'src/services/api/api';
import {DropinArrivalRequest} from 'src/services/api/types/types';

function getBaseUrl() {
    let uri = document.location.href;

    if (uri.endsWith('/')) {
        uri = uri.substring(0, uri.length - 1);
    }

    const slashIdx = uri.lastIndexOf('/');

    uri = uri.substring(0, slashIdx);

    return uri;
}

export function DropinDeviceCompleted() {
    const {
        dataState: {clinicId, persons, reasonState}
    } = useArrivalContext();
    const [error, setError] = useState(false);
    const {sessionState, clearSession} = useSessionContext();

    useEffect(() => {
        if (reasonState.appointmentType === null) return;

        const data: DropinArrivalRequest = {
            type: reasonState.appointmentType.id,
            patients: persons.map(toDropinArrivalPerson)
        };

        performDropinArrival(clinicId, data, sessionState.userJwt)
            .then((res) => {
                clearSession({redirectToHome: false});
                const url = getBaseUrl();
                document.location.href = `${url}/info/${res.id}`;
            })
            .catch((e) => {
                setError(true);
                clearSession({redirectToHome: false});
            });
    }, []);

    if (error) {
        return <>Error</>;
    }

    return (
        <div style={{width: '100px', height: '100px', margin: '0 auto'}}>
            <Spinner />
        </div>
    );
}
